<template>
    <div>
        <p class="login-label">手机号</p>
        <input type="text" v-model.trim="mobile"
            class="form-item-base login-input disable_num_arrow"
            :class="{'login-input--hasval': mobile}"
            :maxlength="11"
            placeholder="请输入手机号"/>

        <p class="login-label u-mt16">密码</p>
        <input type="password" v-model.trim="password"
            class="form-item-base login-input"
            :class="{'login-input--hasval': password}"
            maxlength="30"
            @keydown.enter="doLogin"
            placeholder="请输入密码"/>

        <!-- 需要输入图形验证码 -->
        <div v-if="needInputCaptcha">
            <p class="login-label u-mt16">图形验证码</p>
            <div class="login-captcha-container">
                <input type="text" v-model.trim="captcha"
                   class="form-item-base login-input"
                   :class="{'login-input--hasval': captcha}"
                   :maxlength="6"
                   @keydown.enter="doLogin"
                   placeholder="请输入图形验证码"/>
                <img :src="captchaObj ? 'data:image/jpeg;base64,' + captchaObj.base64Data : ''" class="login-captcha" @click="changeCaptcha($event)"/>
            </div>
        </div>
        <p class="login-errmsg-container" v-if="validateMag && validateCode != MOBILE_PWD_FAIL_TOOMANY_TIMES">
            <span class="login-errmsg">
                {{validateMag}}，请前往 <a href="javascript:;" @click="navToMobileLogin" class="text-main">快捷登录</a>
            </span>
        </p>

        <a href="javascript:;" class="form-item-base login-btn u-mt16"
           :class="{'login-btn--active': !disabledLoginBtn}"
           @click="doLogin">
            <span v-if="isSubmitting">登录中...</span>
            <span v-else>登录</span>
        </a>

    </div>
</template>

<script>
    import axios from 'axios'
    import MobileLogin from './MobileLogin.vue'
    import ErrorCodeMixin from '../mixin/ErrorCodeMixin.vue'
    import UtilMixin from '../mixin/UtilMixin.vue'

    export default {
        components: { MobileLogin },
        mixins: [ErrorCodeMixin, UtilMixin],
        data: function() {
            return {
                mobile: '',
                password: '',
                captcha: '',
                captchaKey: '',

                validateCode: 0,
                validateMag:'',
                needInputCaptcha: false,    //需要输入验证码
                captchaObj: null,

                isSubmitting: false
            }
        },
        computed: {
            disabledLoginBtn: function() {
                return this.isInvalidMobile ||
                        !this.mobile ||
                        !this.password ||
                        (this.needInputCaptcha && !this.captcha) ||
                        this.isSubmitting
            },
            isInvalidMobile: function() {
                return !this.mobile || this.mobile.length < 11
            }
        },
        methods: {
            doLogin: function() {
                if(this.disabledLoginBtn) return;

                this.isSubmitting = true

                let data = {
                    mobile: this.mobile,
                    password: this.password,
                    site: meta.site
                }
                if(this.needInputCaptcha) {     //需要输入验证码
                    data.captcha = this.captcha
                    data.captchaKey = this.captchaObj.key
                }

                //已绑定过贝壳经纪学堂帐号， 登录成功
                axios.post('/api/login/mobilePwd', this.stringify(data)).then((response) => {
                    this.isSubmitting = false
                    if(response.data.code == 0) {   //验证成功， 发送成功消息
                        this.$emit('on-success', response.data);
                    } else {
                        this._setErrorInfo(response)

                        if (this.validateCode === this.MOBILE_PWD_FAIL_TOOMANY_TIMES) {  //需要输入验证码
                            this.needInputCaptcha = true
                        }

                        if(this.needInputCaptcha) {
                            this.changeCaptcha()
                        }
                    }
                }).catch(({ response }) => {
                    this.isSubmitting = false
                    this._setErrorInfo(response)
                })
            },
            loginSuccess: function(data) {
                this.$emit('on-success', data)
            },
            changeCaptcha: function() {
                axios.get('/api/login/captcha').then((res) => {
                    this.captchaObj = res.data
                })
            },
            _setErrorInfo: function(response) {
                this.validateCode = response.data.code
                this.validateMag = response.data.message
                if(response.status ===  500) {
                    this.validateMag = '服务器异常'
                }
            },
            navToMobileLogin: function() {
                this.$emit('on-failure', this.validateCode)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// PasswordLogin.vue?d3782990